module.exports = __webpack_public_path__ + "img/20191220152224483.32db7e69.jpg";